export type ResourceIndexSelection<T> = {
  selectedIds: string[]
  onChange: (ids: string[]) => void
  getSelectable?: (row: T) => boolean
  getLabel?: (row: T) => string
}

export function selectableRowIds<T>(rows: T[], getRowId: (row: T) => string, selection: ResourceIndexSelection<T>) {
  return rows.filter((row) => selection.getSelectable?.(row) ?? true).map(getRowId)
}

export function applyIndexSelection<T>({
  rows,
  selection,
  getRowId,
  type,
  toggle,
  target,
}: {
  rows: T[]
  selection: ResourceIndexSelection<T>
  getRowId: (row: T) => string
  type: 'all' | 'page' | 'single' | 'multi' | 'range'
  toggle: boolean
  target?: string | [number, number]
}) {
  let changedIds = selectableRowIds(rows, getRowId, selection)
  if ((type === 'single' || type === 'multi') && typeof target === 'string')
    changedIds = changedIds.includes(target) ? [target] : []
  else if ((type === 'multi' || type === 'range') && Array.isArray(target)) {
    changedIds = rows
      .slice(target[0], target[1] + 1)
      .filter((row) => selection.getSelectable?.(row) ?? true)
      .map(getRowId)
  }
  const next = new Set(selection.selectedIds)
  changedIds.forEach((id) => (toggle ? next.add(id) : next.delete(id)))
  selection.onChange([...next])
}
